import { push } from "connected-react-router";
import React, { useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  APPLICATION_MODE_NEW,
  APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE,
  DOCUMENT_CONTENT_TYPE_PDF,
  DOCUMENT_TYPE_CRIMINAL_RECORD,
  individualFileSizeAllowedInMB,
  LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION,
  REQUEST_STATUS,
  ROUTE_PATH,
} from "../../app/constants";
import {
  NOT_LICENCED,
} from "../../redux/slice/primaryAgencyApplicationSlice";
import {
  Header,
  Button,
  NavigationLinkButton,
  Paragraph,
  ErrorMark,
} from "../../components/RegularComponents";
import InputSelectForm from "../../components/InputSelectForm";
import TopNavigationBar from "../TopNavigationBar";
import { ERROR_STRING } from "../../app/errors";
import { setAgencyCriminalRecordsDocuments } from "../../redux/slice/primaryAgencyApplicationSlice";
import { setCurrentAgentCriminalRecordsDocuments } from "../../redux/slice/additionalApplicationsSlice";
import {
  fileNameWithLengthLimit,
  fileTypeEnum,
  extractBase64,
  validateFileName,
  acceptedFileFormats,
  convertFileDataForUrl,
} from "../../app/documentUploadUtils";
import { saveBusinessLicenceApplicationData } from "../../redux/slice/businessLicenceApplicationSlice";
import {
  DocumentViewerFileNameLink,
  DownloadFileNameLink,
} from "../../components/DocumentViewer/DocumentFileComponent";
import { fetchDocumentData } from "../../redux/slice/supportingDocumentsSlice";
import DocumentViewer from "../../components/DocumentViewer/DocumentViewer";
import { applicationTypeFromLicenceSubType } from "../../redux/slice/applicationsUtils";
import { currentAgentApplicationSelector } from "../../redux/selector/collectorApplicationSelector";

export const UploadCriminalRecordCheck = (props) => {
  const isPrimaryAgencyApplication = props.forPrimaryAgency;
  // const isPrimaryAgencyApplication =
  //     props.location.state && props.location.state.primaryAgencyApplication;
  const agentApplication = useSelector(currentAgentApplicationSelector);
  let applicationType = APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE
  let isPrincipalBroker = false;
  
  if(!isPrimaryAgencyApplication && agentApplication) { 
    const { licencingSubType } = agentApplication;
    applicationType = applicationTypeFromLicenceSubType(licencingSubType);
    isPrincipalBroker = licencingSubType === LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION;
  }

  // This will change to primaryAgent when branch is pushed
  const uploadCriminalRecordCheck = useSelector((state) => {
    let criminalRecords = [];

    if (
      isPrimaryAgencyApplication &&
      state.primaryAgencyApplication.application?.documents
    ) {
      criminalRecords =
        state.primaryAgencyApplication.application?.documents.filter(
          (docs) =>
            docs.documentType === DOCUMENT_TYPE_CRIMINAL_RECORD &&
            docs.changeType !== "DELETE"
        );
    } else if (agentApplication?.documents) {
      criminalRecords = agentApplication?.documents.filter(
        (docs) => (docs.documentType === DOCUMENT_TYPE_CRIMINAL_RECORD &&
                    docs.changeType !== "DELETE")
      );
    }

    return criminalRecords;
  });

  const companyRjscDetails = useSelector(
    (state) =>
      state.primaryAgencyApplication?.application?.businessLicenceData
        ?.companyRjscDetails
  );

  const serverSaveRequest = useSelector(state => state.primaryAgencyApplication.serverRequestStatus)

  const peopleList = useMemo(() => {
    if (companyRjscDetails?.businessData?.peopleList) {
      return companyRjscDetails?.businessData?.peopleList;
    }

    return [];
  }, [companyRjscDetails]);

  const people = [];

  peopleList.forEach((person) => {
    people.push(person);
  });

  // array of objects with a name and file
  const [criminalRecordCheckDetails, setCriminalRecordCheckDetails] = useState(
    uploadCriminalRecordCheck.length > 0
    ? uploadCriminalRecordCheck.map((document) => {
        return { entityId: document.entityId, file: document };
      })
    : [
        {
          entityId: peopleList?.length > 0 ? peopleList[0].entityId : null,
          file: {},
        },
      ]);

  const [properFileCheck, setProperFileCheck] = useState(
    uploadCriminalRecordCheck.length > 0
      ? uploadCriminalRecordCheck.map((x) => false)
      : [false]
  );
  const [showValidationError, setShowValidationError] = useState(false);
  const [applicationSaveError, setApplicationSaveError] = useState(false);
  const [errorString, setErrorString] = useState("")

  const { isModal = false, onEditSave = () => {} } = props;

  const dispatch = useDispatch();

  const applicationMode = APPLICATION_MODE_NEW;
  const [openDocumentViewer, setOpenDocumentViewer] = useState(false);
  const [documentViewerDocument, setDocumentViewerDocument] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);

  const SubSeparator = () => {
    return (
      <hr
        className="bottomMarginNormal"
        style={{
          borderColor: "#0058a466",
          borderWidth: "3px",
          width: "65%",
          marginLeft: "0px",
        }}
      />
    );
  };

  const validateData = () => {
    const validFiles = criminalRecordCheckDetails.filter(record => (record.file && Object.keys(record.file).length !== 0))
    if(validFiles.length === 0) {
      setErrorString(ERROR_STRING.AT_LEAST_ONE_FILE_MISSING_ERROR) 
      return false
    }

    return true
  }

  const handleSaveAndNext = () => {
    if (!validateData()) {
      setShowValidationError(true);
      return;
    }

    setShowValidationError(false);

    // Need to save associate broker file somewhere ...
    let nextPath = `${ROUTE_PATH.MRA_APP}${ROUTE_PATH.MRA_UPLOAD_PROOF_OF_INSURANCE}`;

    if(!isPrimaryAgencyApplication) {
      if(isPrincipalBroker) {
        nextPath = `${ROUTE_PATH.MRA_APP}${ROUTE_PATH.MRA_BROKER_CONTACT_INFORMATION}`;
      } else {
        const { previouslyLicencedStatus } = agentApplication?.businessLicenceData
        if(previouslyLicencedStatus === NOT_LICENCED) {
          //For associate mortgage broker
          nextPath=`${ROUTE_PATH.MRA_APP}${ROUTE_PATH.MRA_BROKER_APPLICATION_REVIEW}`
        } else {
          nextPath = `${ROUTE_PATH.MRA_APP}${ROUTE_PATH.MRA_CONFIRM_COMPLETION_REGULATORY_INFO}`;
        }
      }
    }

    !isPrimaryAgencyApplication
      ? dispatch(
          setCurrentAgentCriminalRecordsDocuments(
            criminalRecordCheckDetails.map((criminalRecord) => {
              return criminalRecord.file;
            })
          )
        )
      : dispatch(
          setAgencyCriminalRecordsDocuments(
            criminalRecordCheckDetails.map((criminalRecord) => {
              return criminalRecord.file;
            })
          )
        );

    dispatch(
      saveBusinessLicenceApplicationData(applicationType, applicationMode)
    )
      .then((data) => {
        // On to the next item
        dispatch(push(nextPath));
      })
      .catch((err) => {
        setApplicationSaveError(true);
      });
  };

  const handleSaveandClose = () => {
    if (!validateData()) {
      setErrorString(ERROR_STRING.AT_LEAST_ONE_FILE_MISSING_ERROR)
      setShowValidationError(true);
      return;
    }

    setShowValidationError(false);

    !isPrimaryAgencyApplication
      ? dispatch(
          setCurrentAgentCriminalRecordsDocuments(
            criminalRecordCheckDetails.map((criminalRecord) => {
              return criminalRecord.file;
            })
          )
        )
      : dispatch(
          setAgencyCriminalRecordsDocuments(
            criminalRecordCheckDetails.map((criminalRecord) => {
              return criminalRecord.file;
            })
          )
        );

    onEditSave();
  };

  const fileSizeReplacement = (string, fileSize) => {
    const replaceRegExp = /<file_size>/g;
    const errorString = string.replace(replaceRegExp, fileSize + "MB");
    return errorString;
  };

  const fileComponent = (id, file, index) => {
    return (
      <>
        <div className="supportingDocumentsFileContentWrapper">
          <span className="fileName">
            {file.documentContentType === DOCUMENT_CONTENT_TYPE_PDF ? (
              <DocumentViewerFileNameLink
                id={"supporting-document-view-file-" + file.filename}
                key={"supporting-document-view-file-" + file.filename}
                file={file}
                onClick={() => {
                  if (file.data) {
                    let fileDataUrl = convertFileDataForUrl(
                      file.data,
                      file.documentContentType
                    );
                    setDocumentViewerDocument(fileDataUrl);
                    setOpenDocumentViewer(true);
                    setSelectedFile(file);
                  } else {
                    // download data and then view it.
                    if (file.guid) {
                      dispatch(fetchDocumentData(file.guid))
                        .then((downloadFile) => {
                          if (downloadFile) {
                            let fileDataUrl = convertFileDataForUrl(
                              downloadFile.data,
                              downloadFile.documentContentType
                            );
                            setDocumentViewerDocument(fileDataUrl);
                            setOpenDocumentViewer(true);
                            setSelectedFile(downloadFile);
                          }
                        })
                        .catch((error) => {
                          console.error(error);
                        });
                    }
                  }
                }}
              />
            ) : (
              <DownloadFileNameLink
                id={"supporting-document-download-file-" + file.filename}
                componentKey={
                  "supporting-document-download-file-" + file.filename
                }
                file={file}
              />
            )}
          </span>

          <NavigationLinkButton
            id={id + "-remove-link"}
            text={"- Remove this file"}
            onClick={() => {
              let criminalRecordCheckDetailsUpdate = [
                ...criminalRecordCheckDetails,
              ];

              criminalRecordCheckDetailsUpdate[index].file = {};

              setCriminalRecordCheckDetails(criminalRecordCheckDetailsUpdate);
            }}
          />
        </div>
      </>
    );
  };

  const CriminalRecordBlock = ({ data = [] }) => {
    return (
      <>
        {data.map((element, index) => (
          <>
            <div className="row">
              <div className="col-lg-8">
                {isPrimaryAgencyApplication && (
                  <div className="row">
                    <div className="col-lg-4">
                      <fieldset className="ns-fieldset">
                        <label
                          id="upload-criminal-record-check-label"
                          className="ns-label"
                        >
                          Name
                        </label>
                        <InputSelectForm
                          id={"upload-criminal-record-check-select"}
                          peopleList
                          options={people}
                          currentValue={element.entityId}
                          onChange={(e) => {
                            let criminalRecordCheckDetailsUpdate = [
                              ...criminalRecordCheckDetails,
                            ];

                            criminalRecordCheckDetailsUpdate[index].entityId =
                              e.target.value;

                            setCriminalRecordCheckDetails(
                              criminalRecordCheckDetailsUpdate
                            );
                          }}
                        />
                      </fieldset>
                    </div>
                  </div>
                )}
                {criminalRecordCheckDetails[index].file &&
                Object.keys(criminalRecordCheckDetails[index].file).length >
                  0 ? (
                  <div className="row">
                    <div className="col-xs-12 col-lg-8">
                      {fileComponent(
                        "criminal-records-form",
                        criminalRecordCheckDetails[index].file,
                        index
                      )}
                    </div>
                  </div>
                ) : (
                  <div className="row">
                    <div className="col-xs-12 col-lg-8">
                      <div className="row">
                        <div className="col-xs-12">
                          <fieldset
                            className="ns-fieldset"
                            id="criminal-records-form"
                          >
                            <div className={"ns-fieldset"}>
                              <div className="ns-file-input">
                                <div className="row">
                                  <div className="col-xs-12">Upload a file</div>
                                </div>
                                <div className="row">
                                  <div className="col-xs-4">
                                    <label
                                      className="btn btn-primary"
                                      id="upload-criminal-record-check-file-label"
                                      htmlFor={`criminal-records-form-${index}-id`}
                                    >
                                      Choose File
                                    </label>
                                    <input
                                      className="ns-input"
                                      style={{display: "none"}}
                                      type="file"
                                      id={`criminal-records-form-${index}-id`}
                                      name={`criminal-records-form-${index}-id`}
                                      accept={acceptedFileFormats(
                                        DOCUMENT_TYPE_CRIMINAL_RECORD
                                      ).join(",")}
                                      multiple={false}
                                      value=""
                                      onInput={(e) => {
                                        if (e.target.files.length > 0) {
                                          let file = e.target.files[0];

                                          // individual file size can not be more than 15 MB
                                          if (
                                            file.size >
                                            individualFileSizeAllowedInMB * 2 ** 20
                                          ) {
                                            alert(
                                              fileSizeReplacement(
                                                ERROR_STRING.SUPPORTING_DOC_VERY_LARGE_INDIVIDUAL_FILE,
                                                individualFileSizeAllowedInMB
                                              )
                                            );
                                            return;
                                          } else if (!validateFileName(file.name)) {
                                            alert(
                                              "File name is not valid. Please select another file."
                                            );
                                            return;
                                          }

                                          let reader = new FileReader();
                                          reader.onload = (readerData) => {
                                            let criminalRecordCheckDetailsUpdate = [
                                              ...criminalRecordCheckDetails,
                                            ];

                                            criminalRecordCheckDetailsUpdate[
                                              index
                                            ].file = {
                                              filename: fileNameWithLengthLimit(
                                                file.name
                                              ),
                                              documentContentType: fileTypeEnum(
                                                file.type
                                              ),
                                              data: extractBase64(
                                                readerData.target.result
                                              ),
                                              changeType: "SAVE",
                                              documentType:
                                                DOCUMENT_TYPE_CRIMINAL_RECORD,
                                              fileSize: file.size,
                                              entityId: element.entityId,
                                            };

                                            setCriminalRecordCheckDetails(
                                              criminalRecordCheckDetailsUpdate
                                            );
                                          };
                                          reader.readAsDataURL(file);

                                          // reset validation errors
                                          setShowValidationError(false);
                                        }
                                      }}
                                    />
                                  </div>
                                  <div style={{ paddingTop: "5px", marginLeft: "-35px" }} className="col-xs-7">
                                    No file choosen
                                  </div>
                                </div>
                              </div>
                            </div>
                          </fieldset>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className="col-lg-2">
                {index > 0 && (
                  <NavigationLinkButton
                    id={"branch-remove-link"}
                    text={"- Remove record"}
                    onClick={() => {
                      let criminalRecordCheckDetailsUpdate = [
                        ...criminalRecordCheckDetails,
                      ];
                      criminalRecordCheckDetailsUpdate.splice(index, 1);
                      setCriminalRecordCheckDetails(
                        criminalRecordCheckDetailsUpdate
                      );
                    }}
                  />
                )}
              </div>
            </div>
            {!isPrimaryAgencyApplication && <SubSeparator />}
          </>
        ))}
      </>
    );
  };

  // useEffect(() => {

  //   if( uploadCriminalRecordCheck.length > 0) { 
  //     const docs = uploadCriminalRecordCheck.map((document) => {
  //       return { entityId: document.entityId, file: document };
  //     })
  //     setCriminalRecordCheckDetails(docs)
  //   }

  // }, [
  //   uploadCriminalRecordCheck,
  //   setCriminalRecordCheckDetails
  // ])

  let title = "Upload criminal record check document for the applicant";
  
  if(!isPrimaryAgencyApplication && isPrincipalBroker) {
    title = 'Upload your criminal record check document'
  }

  return (
    <>
      <div className={!isModal ? "container" : ""}>
        {!isModal && (
          <>
            <TopNavigationBar  {...props} applicationType={applicationType} applicationMode={applicationMode} />
            <div className="row">
              <div className="col-xs-12 col-lg-8">
                {!isPrimaryAgencyApplication ? (
                  <>
                    <Header
                      style={{ paddingBottom: "30px" }}
                      id="company-fiscal-end-date-header"
                      header={title}
                    />
                    <Paragraph
                      style={{ paddingBottom: "10px" }}
                      id="company-fiscal-end-date-header"
                      text={[
                        "An applicant for a licence or renewal must obtain a criminal record check from the Royal Canadian Mounted Police, a Canadian municipal police force or the Canadian military police that is dated no earlier than 3 months before the date of application.",
                        "Criminal record checks will not be accepted from third party providers."
                      ]}
                    />
                  </>
                ) : (
                  <>
                    <Header
                      style={{ paddingBottom: "30px" }}
                      id="company-fiscal-end-date-header"
                      header="Upload criminal record check"
                    />
                    <Paragraph
                      style={{ paddingBottom: "10px" }}
                      id="company-fiscal-end-date-header"
                      text={[
                        "The following individuals must get a criminal record check from the Royal Canadian Mounted Police, a Canadian municipal police force or the Canadian military police that is dated no earlier than 3 months before the date of application.",
                        `<ul>
                          <li>The Compliance Officer or Principal Broker of your business</li>
                          <li>Each officer if your business is a corporation</li>
                          <li>Each officer or each general partner if your business is a limited partnership</li>
                          <li>Each partner if your business is a partnership</li>
                          <li>Each officer of the corporation if your business is a partner that is a corporation</li>
                          <li>Each sole proprietor if your business is a sole proprietorship</li>
                        </ul>`,
                        `Criminal record checks will not be accepted from third party providers.`,
                      ]}
                    />
                  </>
                )}
              </div>
            </div>
          </>
        )}

        <CriminalRecordBlock data={criminalRecordCheckDetails} />

        <div className="row">
          <div className="col-xs-12 col-lg-8">
            <Paragraph
              style={{ paddingBottom: "20px" }}
              id="upload-mortgage-education-text"
              text={[
                "The maximum file size allowed is 15 MB per file and 50 MB total. Supported document types are Microsoft Word, Microsoft Office Excel, or Adobe PDF.  All digital files must be in an uncompressed format, i.e no zip or ARC files.",
              ]}
            />
          </div>
        </div>
        {isPrimaryAgencyApplication && (
          <div className="row bottomMarginMedium">
            <div className={"col-lg-8"}>
              <NavigationLinkButton
                id={"criminaly-history-add-more-link"}
                text={
                  "+ Add another record for another director, partner, officiers, sole prop"
                }
                onClick={() => {
                  setCriminalRecordCheckDetails([
                    ...criminalRecordCheckDetails,
                    {
                      entityId:
                        peopleList?.length > 0 ? peopleList[0].entityId : null,
                      file: "",
                    },
                  ]);

                  setProperFileCheck([...properFileCheck, false]);
                }}
              />
            </div>
          </div>
        )}

        <div className="row">
          <div
            className={
              "col-lg-4" + (showValidationError || applicationSaveError)
                ? " has-error"
                : ""
            }
          >
            <Button
              id="company-fiscal-end-date-button"
              style={{ margin: "0 10px 10px 0" }}
              buttonType={"regular_primary"}
              text={!isModal ? "Save and next" : "Save and close"}
              showSpinner={!applicationSaveError && 
                            (serverSaveRequest === REQUEST_STATUS.IN_PROGRESS)}
              onClick={!isModal ? handleSaveAndNext : handleSaveandClose}
              disabled={(serverSaveRequest === REQUEST_STATUS.IN_PROGRESS)}
            />
            {(applicationSaveError || showValidationError) && ErrorMark()}
            {showValidationError && (
              <div className="ns-error-message">
                <span className="ns-visually-hidden">Error:</span>
                {errorString}
              </div>
            )}
            {applicationSaveError && (
              <div className="ns-error-message">
                <span className="ns-visually-hidden">Error:</span>
                {ERROR_STRING.APPLICATION_SAVE_ERROR}
              </div>
            )}
          </div>
        </div>

        <DocumentViewer
          fileData={documentViewerDocument}
          isOpen={openDocumentViewer}
          fileName={selectedFile?.filename}
          handleClose={() => setOpenDocumentViewer(false)}
        />
      </div>
    </>
  );
};
